import React from 'react';
import * as S from './Skeleton.styled';
export const Skeleton = ({ gap = 0, aligment = 'vertical', children, ...props }) => {
    return (React.createElement(S.Skeleton, { "$gap": gap, "$aligment": aligment, "data-testid": "Skeleton", ...props }, children));
};
export const SkeletonShape = ({ variant = 'rectangle', radius, width = '100%', height = 'auto', ...props }) => {
    return (React.createElement(S.Shape, { "$variant": variant, "$radius": radius, "$width": width, "$height": height, "data-testid": "Skeleton.Shape", ...props }, "\u200C"));
};
Skeleton.Shape = SkeletonShape;
